const s = require("./api.module.scss");

import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import classNames from "classnames";
import Select, { SelectItem } from "components/select";
import Tab_tryout from "./tab_tryout";
import Tab_request from "./tab_request";
import Tab_response from "./tab_response";
import { PageList } from "core/pages/pageList"
import { horizons } from "core/pages/navigation"

interface OwnState {
    applicationState: ApplicationState;
}


type PageProps = OwnState & WithTranslation;

export const page_config: PageList =
{
    apiUrl: "",
    webUrl: "api",
    menu: "", //no menu link should be created for this page
    apiType: "",
    title: "common:titleApi",
    response: "",
    dto: "",
    parameters: "",
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};

const Page = ({ t, applicationState }: PageProps) => {

    useEffect(() => {
        applicationState.handleInputAvailablilityChange("", false, false, []);
    }, []);

    const jsonStyle = {
        main: "line-height:1.3;color:#000;overflow-wrap:break-word;white-space:pre-wrap;",
        error: "line-height:1.3;color:#a11;",
        key: "color:#a11;",
        string: "color:#000;",
        value: "color:#164;",
        boolean: "color:#219;",
    };

    const pageList = applicationState.pages.map(p => p.config);

    let apis = pageList.filter(a => a.apiUrl != "");
    for(let i = 0; i < horizons.length; ++i) {
        apis = apis.filter(a => a.apiUrl !== horizons[i] + "_");
    }
    apis = apis.sort((a, b) =>
        pageList.findIndex(x => x.apiUrl.toLowerCase() == a.apiUrl.toLowerCase()) < pageList.findIndex(x => x.apiUrl.toLowerCase() == b.apiUrl.toLowerCase()) ? -1 : 1
    );

    const [selectedEndpoint, setEndpoint] = useState(apis[0]);
    const [selectedTab, setSelectedTab] = useState("request");

    const apiList = apis.map(a => {
        const text = a.apiUrl.substring(0, a.apiUrl.indexOf("_")) + " - ";
        return { id: a.apiUrl, text: (text.startsWith("ID") ? text : text.substring(2)) + t(a.title) };
    }).sort((a, b) => a.id < b.id ? -1 : 1);

    const baseUrl = window.location.protocol + "//" + location.host + applicationState.apiService + "/";
    const handleEndpointChange = (item: SelectItem) => { setEndpoint(apis.filter(a => a.apiUrl === item.id)[0]); };
    return (
        <>
            <SheetHeader showDownload={false} applicationState={applicationState} title={t("common:titleApi")} senderId="api" />

            <div className="shadow-sm bg-white rounded" style={{ position: "relative", margin: "1rem" }} >
                <div className={s.marginDiv}>
                    <div className="inputlabel">Endpoint</div>
                    <Select enabled={true} data={apiList} onChange={handleEndpointChange} selectedItem={{ id: selectedEndpoint.apiUrl, text: t(selectedEndpoint.title) }} />
                    <div className="inputlabel">Url</div>
                    <input className={classNames(s.maxWidth, "inputBorder")} type="text" value={baseUrl + selectedEndpoint.apiType + "/" + selectedEndpoint.apiUrl} readOnly />
                </div>

                <div className="subHeader">
                    <div className={classNames(s.selectableBorder, "request" === selectedTab ? s.selected : "")} onClick={() => setSelectedTab("request")}>Request</div>
                    <div className={classNames(s.selectableBorder, "response" === selectedTab ? s.selected : "")} onClick={() => setSelectedTab("response")}>Response</div>
                    <div className={classNames(s.selectableBorder, "tryout" === selectedTab ? s.selected : "")} onClick={() => setSelectedTab("tryout")}>Try it out</div>
                </div>
                <div className={s.json}>
                    {"request" === selectedTab ? <Tab_request applicationState={applicationState} selectedEndpoint={selectedEndpoint} jsonStyle={jsonStyle} /> : ""}
                    {"response" === selectedTab ? <Tab_response applicationState={applicationState} selectedEndpoint={selectedEndpoint} jsonStyle={jsonStyle} /> : ""}
                    {"tryout" === selectedTab ? <Tab_tryout url={baseUrl + selectedEndpoint.apiType + "/" + selectedEndpoint.apiUrl + "?"} applicationState={applicationState} selectedEndpoint={selectedEndpoint} jsonStyle={jsonStyle} /> : ""}
                </div>
            </div>
        </>
    );
};


export default withTranslation()(Page);
